import React from 'react'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const PsNavBar = (): React.ReactElement => {
  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/projects/personal-status">
          Personal Status
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/projects/personal-status/privacy">
              Privacy Policy
            </Nav.Link>
            <Nav.Link as={Link} to="/projects/personal-status/terms-and-conditions">
              Terms & Conditions
            </Nav.Link>
            <Nav.Link as={Link} to="/">
              Beecode
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
